<template>
  <el-dialog
    title="复合片出库"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="100px"
      size="small"
    >
      <el-form-item label="复合片" prop="pdc_id">
        <el-select
          size="small"
          class="fix-width"
          placeholder="请搜索或选择"
          filterable
          remote
          :remote-method="getPdcs"
          :loading="loading"
          v-model="model.pdc_id"
        >
          <el-option
            v-for="item in pdcs"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="新 / 旧" prop="category">
        <el-select v-model="model.category" style="width: 100%">
          <el-option key="1" label="新齿" :value="1"></el-option>
          <el-option key="2" label="旧齿" :value="2"></el-option>
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="出库类型" prop="stock_out_category">
        <el-select v-model="model.stock_out_category" class="fix-width">
          <el-option
            v-for="(value, index) in ItemStockOutCategoryMap"
            :key="index"
            :label="value"
            :value="parseInt(index)"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="收货仓库"
        prop="stock_out_stockroom_id"
        v-if="model.stock_out_category == 2"
      >
        <el-select v-model="model.stock_out_stockroom_id" class="fix-width">
          <el-option
            v-for="item in stockrooms"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item
        label="钻头序列号"
        prop="drills"
        v-if="model.stock_out_category == 1"
      >
        <DrillSelect v-model="model.drills"></DrillSelect>
        <!-- <el-input
          class="fix-width"
          v-model="model.drill_serial_numbers"
        ></el-input> -->
      </el-form-item>
      <el-form-item label="数量" prop="number">
        <el-input
          class="fix-width"
          type="number"
          min="1"
          step="1"
          v-model.number="model.number"
        ></el-input>
      </el-form-item>
      <el-form-item label="物流公司" prop="logistic_company">
        <ShipperSelect v-model="model.logistic_company"></ShipperSelect>
      </el-form-item>
      <el-form-item label="物流单号" prop="logistic_number">
        <el-input
          placeholder="物流单号"
          v-model="model.logistic_number"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input placeholder="备注" v-model="model.remark"></el-input>
      </el-form-item>
      <!-- <el-form-item label="收件人手机号" prop="receiver_mobile">
        <el-input
          placeholder="使用顺丰时必填"
          v-model="model.receiver_mobile"
        ></el-input>
      </el-form-item> -->
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  pdcOutRecordNew,
  pdcOutRecordUpdate,
  pdcList,
  stockroomList,
} from '@/service/getData'
import { ItemStockOutCategoryMap } from '@/config/global'

import DrillSelect from '@/components/select/drill_multiple_select'
import ShipperSelect from '@/components/select/shipper_select'

export default {
  components: {
    DrillSelect,
    ShipperSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
        this.model.drills = null
      } else {
        setTimeout(() => {
          if (this.model.id) {
            this.getPdcs('', this.model.pdc_id)
          }
        }, 300)
      }
    },
  },
  data() {
    return {
      ItemStockOutCategoryMap,
      stockrooms: [],
      visible: this.show,
      loading: false,
      pdcs: [],
      rules: {
        pdc_id: [{ required: true, message: '请选择复合片' }],
        stock_out_stockroom_id: [{ required: true, message: '请选择收货仓库' }],
        // drill_serial_numbers: [{ required: true, message: '请填写钻头' }],
      },
    }
  },
  created() {
    this.getStockrooms()
  },
  methods: {
    async getStockrooms() {
      let res = await stockroomList()
      if (res.status == 0) {
        this.stockrooms = res.data.list
      }
    },
    async getPdcs(query, pdc_id = 0) {
      if (query !== '' || pdc_id > 0) {
        this.loading = true
        let res = await pdcList({ query: query, pdc_id: pdc_id })
        if (res.status == 0) {
          this.pdcs = res.data.list
          this.loading = false
        }
      } else {
        this.pdcs = []
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          data.drill_serial_numbers = data.drills.join(',')
          if (this.model.id > 0) {
            let res = await pdcOutRecordUpdate(data)
            if (res.status == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await pdcOutRecordNew(data)
            if (res.status == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
<style scoped>
.fix-width {
  width: 100%;
}
</style>